import React from 'react';
import styled, { css } from 'styled-components';
import SystemEntryExpandableCard from './SystemEntryExpandableCard';
import SystemEntryMediaCard from './SystemEntryMediaCard';
import mq from '../../utils/mq';
import { AnimatePresence } from 'framer-motion';

const SystemEntriesExplainerOuterContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 20px;
  ${mq.mobile(css`
    display: flex;
    flex-direction: column-reverse;
    gap: 0px;
  `)};
`;

const SystemEntriesExplainerLeftColumn = styled.div`
  grid-column: 1 / span 4;
`;

const SystemEntriesExplainerRightColumn = styled.div`
  grid-column: 6 / span 7;
  aspect-ratio: 629/472;
  width: 100%;
`;

export default function SystemEntriesExplainer({
  systemEntries,
  activeSystemEntry,
  setActiveSystemEntry
}: {
  systemEntries: any[];
  activeSystemEntry: number;
  setActiveSystemEntry: (index: number) => void;
}) {
  return (
    <SystemEntriesExplainerOuterContainer>
      <SystemEntriesExplainerLeftColumn>
        {systemEntries.map((system, i) => (
          <SystemEntryExpandableCard
            key={i}
            system={system}
            active={activeSystemEntry === i}
            setActive={() => setActiveSystemEntry(i)}
          />
        ))}
      </SystemEntriesExplainerLeftColumn>
      <SystemEntriesExplainerRightColumn>
        <AnimatePresence>
          <SystemEntryMediaCard system={systemEntries[activeSystemEntry]} />
        </AnimatePresence>
      </SystemEntriesExplainerRightColumn>
    </SystemEntriesExplainerOuterContainer>
  );
}
